import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ModulePage from "./pages/ModulePage";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { SmoothScroll } from "./components/SmoothScroll";
import { PencilFilter } from "./components/Sketches";

function App() {
  return (
    <div className="App paper">
      <BrowserRouter>
        <SmoothScroll />
        <PencilFilter />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/module/:slug" element={<ModulePage />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
